import {MUIProLicense} from "@bounce/shared/constants";
import {AuthProvider, SentryProvider} from "./contexts";
import {queryClient} from "@bounce/shared/requests";
import {GlobalStyles, ProgressBarStyle, ThemeConfig, Toast} from "@bounce/shared/ui";
import NiceModal from "@ebay/nice-modal-react";
import {LocalizationProvider} from "@mui/x-date-pickers";
import {AdapterDateFns} from "@mui/x-date-pickers/AdapterDateFns";
import {LicenseInfo} from "@mui/x-license";
import {QueryClientProvider} from "@tanstack/react-query";
import {ReactQueryDevtools} from "@tanstack/react-query-devtools";
import React from "react";
import {BrowserRouter} from "react-router-dom";
import BackofficeApiExceptionManager from "./apis/BackofficeApiExceptionManager";
import BackofficeApiManager from "./apis/BackofficeApiManager";
import {BackofficeUserProvider, TaskProvider} from "./contexts";
import DevToolsPanel from "./dev-tools/DevToolsPanel";
import FlexUiStateWrapper from "./contexts/flex-ui-state/FlexUiStateWrapper";
import Router from "./routes/routes";
import {urls} from "./routes/urls";
import {isDevToolsEnabled} from "@bounce/shared";

const App = () => {
  LicenseInfo.setLicenseKey(MUIProLicense);
  return (
    <BrowserRouter future={{v7_relativeSplatPath: true, v7_startTransition: true}}>
      <QueryClientProvider client={queryClient}>
        <AuthProvider>
          <BackofficeApiManager>
            <BackofficeUserProvider>
              <TaskProvider>
                <SentryProvider urls={urls}>
                  <FlexUiStateWrapper>
                    <LocalizationProvider dateAdapter={AdapterDateFns}>
                      <ThemeConfig>
                        <Toast />
                        <GlobalStyles />
                        <ProgressBarStyle />
                        <BackofficeApiExceptionManager />
                        <NiceModal.Provider>
                          <Router />
                        </NiceModal.Provider>
                      </ThemeConfig>
                    </LocalizationProvider>
                  </FlexUiStateWrapper>
                </SentryProvider>
                <ReactQueryDevtools initialIsOpen={false} />
              </TaskProvider>
              {isDevToolsEnabled() && <DevToolsPanel />}
            </BackofficeUserProvider>
          </BackofficeApiManager>
        </AuthProvider>
      </QueryClientProvider>
    </BrowserRouter>
  );
};

export default App;
